
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { EXTERNAL_LINKS } from '../../constants';
import { TrendingUp, Star, CheckCircle2, ExternalLink } from 'lucide-react';

export const FeedSection: React.FC = () => {
  const { t } = useLanguage();

  // Mock data - Ideally passed as props or fetched
  const feedItems = [
    { type: 'result', title: 'Blue Strike Performance', date: 'Oggi', content: '+2.4% Profitto Giornaliero', icon: <TrendingUp size={20} className="text-green-500" /> },
    { type: 'review', title: 'Marco R.', date: 'Ieri', content: 'Servizio impeccabile, supporto sempre presente.', icon: <Star size={20} className="text-orange-500" /> },
    { type: 'result', title: 'Algo Engine', date: '2 Nov', content: 'TP1 Raggiunto su XAUUSD (+40 Pips)', icon: <CheckCircle2 size={20} className="text-blue-500" /> },
    { type: 'review', title: 'Giulia B.', date: '1 Nov', content: 'Trasparenza mai vista prima in questo settore.', icon: <Star size={20} className="text-orange-500" /> },
  ];

  return (
    <div className="bg-[#151E32] border border-gray-800 rounded-3xl p-10 relative overflow-hidden mb-12">
       <div className="absolute top-0 right-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 pointer-events-none"></div>
       <div className="text-center mb-10">
          <h3 className="text-2xl font-bold text-white mb-2">{t('feedSection.title')}</h3>
          <p className="text-gray-400 text-sm max-w-2xl mx-auto">{t('feedSection.subtitle')}</p>
       </div>
       
       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {feedItems.map((item, i) => (
             <div key={i} className="bg-[#0B1120] border border-gray-700 rounded-xl p-5 hover:-translate-y-1 transition-transform duration-300">
                <div className="flex justify-between items-start mb-4">
                   <div className="p-2 bg-[#151E32] rounded-lg">
                      {item.icon}
                   </div>
                   <span className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">{item.date}</span>
                </div>
                <h4 className="font-bold text-white text-sm mb-2">{item.title}</h4>
                <p className="text-gray-400 text-xs leading-relaxed">"{item.content}"</p>
             </div>
          ))}
       </div>
       <div className="text-center mt-8">
          <a href={EXTERNAL_LINKS.TELEGRAM_ACCESS} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm text-blue-400 hover:text-blue-300 font-bold">
             {t('feedSection.viewAll')} <ExternalLink size={14} className="ml-1" />
          </a>
       </div>
    </div>
  );
};
